import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';

const stripLegacyWeeklyPostingProductParam = (url) => {
  if (typeof url !== 'string') return url;

  const [path, queryString] = url.split('?');
  if (!queryString) return url;

  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  if (normalizedPath !== 'gl-postings/weekly') return url;

  const params = new URLSearchParams(queryString);
  if (!params.get('x3ProductNames')) return url;

  params.delete('x3ProductName');
  return `${path}?${params.toString()}`;
};

const rawBaseQuery = fetchBaseQuery({
  baseUrl: '/api',
  prepareHeaders: (headers, { getState, endpoint }) => {
    // endpoints that should NOT send JSON content-type (file uploads, etc.)
    const endpointsWithoutJson = ['createDeposit', 'uplodeSeedliveFileCash', 'uploadNayaxCsv', 'nayax'];

    if (!endpointsWithoutJson.includes(endpoint)) {
      headers.set('Content-Type', 'application/json; charset=utf-8');
      headers.set('Accept', 'application/json');
    }

    const { user } = getState();
    if (user && user.accessToken) {
      headers.set('authorization', `Bearer ${user.accessToken}`);
    }

    return headers;
  },
});

const baseQuery = (args, api, extraOptions) => {
  const nextArgs =
    typeof args === 'string'
      ? stripLegacyWeeklyPostingProductParam(args)
      : args && typeof args === 'object'
      ? {
          ...args,
          url: stripLegacyWeeklyPostingProductParam(args.url),
        }
      : args;

  return rawBaseQuery(nextArgs, api, extraOptions);
};

export const apiBasePath = createApi({
  baseQuery,
  refetchOnMountOrArgChange: true,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: [
    'Profile',
    'Users',
    'User',
    'Sublocation',
    'Locations',
    'Location',
    'SubLocations',
    'Modem',
    'Modems',
    'Machine',
    'Machines',
    'Models',
    'Model',
    'LocationOwner',
    'Collections',
    'Collection',
    'Drafts',
    'Nayax',
    'Draft',
    'Deposits',
    'Deposit',
    'ModemMachine',
    'Leases',
    'exchangeRate',
    'Intercards',
    'AreaTaxLocations',
    'ManageAreaTaxLocations',
    'AreaTax',
    'MonthlyPostings',
    'WeeklyGLPostings',
    'WeeklyGLPosting',
    'WeeklyGLPostingSublocations',
    'ApprovedWeeklyGLPostings',
    'FinalizedMonthlyPostings',
  ],
  endpoints: () => ({}),
});
